<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <h2>Coodenadas del centro</h2>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-layout column>
            <v-text-field label="Coordenadas"
              v-model="coordinates"
              type="String"
            ></v-text-field>
            <p v-if="showError" class="error-text">Por favor separar coordenadas con ","</p>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="primary" @click="onCancel();">Cancelar</v-btn>
        <v-btn color="primary" @click="onSave()">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    data () {
      return {
        showError: false
      };
    },
    props: {
      dialog: {
        type: Boolean,
        default: false
      },
      coordinates: {
        type: String
      }
    },
    methods: {
      onSave () {
        if (this.validInput()) {
          this.showError = false;
          this.$emit('update:dialog', false);
          this.$emit('update:snackbar', true);
          this.$emit('update:coordinates', this.coordinates);
          this.$emit('save');
        } else {
          this.showError = true;
        }
      },
      onCancel () {
        this.showError = false;
        this.$emit('update:dialog', false);
        this.$emit('update:snackbar', true);
      },
      validInput () {
        const inputedArray = this.coordinates.split(',');
        return inputedArray.length === 2;
      }
    }
  };
</script>


// WEBPACK FOOTER //
// CoordinatesInputForm.vue?86157fe0